import { render, staticRenderFns } from "./EditQuestionModal.vue?vue&type=template&id=42c03297&"
import script from "./EditQuestionModal.vue?vue&type=script&lang=ts&"
export * from "./EditQuestionModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditQuestionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports